import { ElForm }                       from 'element-ui/types/form';
import { GlobalContexts, useGlobals }   from '@/hooks/use-globals';
import { computed, reactive, ref, Ref } from '@vue/composition-api';
import { getViewStorePath }             from '@/store/store.helpers';
import { name as vLogin }               from '@/views/login/login.route';
import { LoginFormFields }              from '@/views/login/login.types';
import { Computed }                     from '@/types';
import { name as vDashboard }           from '@/views/dashboard/dashboard.route';

interface ActiveField {
  username: boolean;
  password: boolean;
}

export default () => {
  const { store, router }: GlobalContexts = useGlobals();
  const activeField: ActiveField = reactive({
    username: false,
    password: false,
  });

  const loginFormFields: LoginFormFields = reactive({
    username: null,
    password: null,
  });

  const loginFormRef: Ref<ElForm> = ref({});
  const getLoginFormErrors: Computed<any> = computed(() => store.getters[ `${getViewStorePath(vLogin)}/getLoginFormErrors` ]);

  const listeners = (type: keyof ActiveField) => reactive({
    focus: () => {
      activeField[ type ] = true;
    },
    blur: () => {
      activeField[ type ] = false;
    },
  });

  const onSubmit = async (): Promise<void> => {
    loginFormRef.value.validate(async (valid: boolean) => {
      if (valid) {
        try {
          const viewModuleKeys: string[] = Object.keys(store.state.views);
          viewModuleKeys.forEach((viewKey: string) => {
            if (store.hasModule([ 'views', `${viewKey}` ]) && viewKey !== vLogin) {
              store.unregisterModule([ 'views', `${viewKey}` ]);
            }
          });
          store.commit('user/setDefaultStateValue');
          await store.dispatch(`${getViewStorePath(vLogin)}/loginUser`, loginFormFields);
          await store.dispatch('user/checkProUsaliAvailability');
          await store.dispatch('user/checkPoImplementationVersion');
        } catch (e) {
          throw Error(e);
        } finally {
          await router.push({ name: vDashboard });
        }
      }
    });
  };

  return {
    loginFormFields,
    loginFormRef,
    getLoginFormErrors,
    activeField,
    listeners,
    onSubmit,
  };
};
